import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  // State to manage the toggle of each section
  const [activeSection, setActiveSection] = useState(null);

  // Function to toggle section visibility
  const toggleSection = (section) => {
    setActiveSection(activeSection === section ? null : section);
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="row">
          <div className="col-lg-3 col-12">
            <div className="footer-widget">
              <h3 onClick={() => toggleSection('quickLinks1')}>
                Discover Us <span className="plus-symbol">+</span>
              </h3>
              <ul className={activeSection === 'quickLinks1' ? 'active' : ''}>
                <li><Link to="/career">Career</Link></li>
                <li><Link to="/t&c">Terms & Conditions</Link></li>
                <li><Link to="/how-we-works">How we Work?</Link></li>
                <li><Link to="/privacy">Privacy Policy</Link></li>
                {/* <li><Link to="/kumbhaatech-affordabe-software-development-chennai">Blogs</Link></li> */}

              </ul>
            </div>
          </div>

          <div className="col-lg-3 col-12">
            <div className="footer-widget">
              <h3 onClick={() => toggleSection('quickLinks2')}>
                Platform<span className="plus-symbol">+</span>
              </h3>
              <ul className={activeSection === 'quickLinks2' ? 'active' : ''}>
                <li><Link to="/">Home</Link></li>
                <li><Link to="/about-us">About Us</Link></li>
                <li><Link to="/services">Services</Link></li>
                <li><Link to="/kumbhaatech-affordabe-software-development-chennai">Projects</Link></li>
                <li><Link to="/kumbhatech-affordable-website-design-chennai">Contact Us</Link></li>
              </ul>
            </div>
          </div>

          <div className="col-lg-3 col-12">
            <div className="footer-widget">
              <h3 onClick={() => toggleSection('services')}>
                Solutions<span className="plus-symbol">+</span>
              </h3>
              <ul className={activeSection === 'services' ? 'active' : ''}>
                <li><Link to="/affordable-website-design-services-chennai">Web Development</Link></li>
                <li><Link to="/cheap-PHP-MYSQL-software-customization-chennai">Software Development</Link></li>
                <li><Link to="/cheap-content-writing-seo-chennai">Content Writing</Link></li>
                <li><Link to="/affordable-strategic-digital-marketing-chennai">Digital Marketing</Link></li>
                <li><Link to="/cheap-overseas-sop-writing-college-universities-visa-chennai">SOP Writing</Link></li>
                <li><Link to="/cheap-domain-registration-chennai">Domain Registration</Link></li>
                <li><Link to="/web-hosting-services">Web Hosting</Link></li>
              </ul>
            </div>
          </div>

          <div className="col-lg-3 col-12">
            <div className="footer-widget">
              <h3 onClick={() => toggleSection('contact')}>
                Address <span className="plus-symbol">+</span>
              </h3>
              <ul className={activeSection === 'contact' ? 'active' : ''}>
                <li style={{ color: '#333' }}>
                  <i className="fa fa-map-marker" aria-hidden="true"></i> Color Gates Apartemnt,Nesamani Nagar Permbakkam,chennai-600100.
                </li>
                <li>
                  <i className="fa fa-envelope" aria-hidden="true"></i>
                  <a href="mailto:support@kumbhatech.com" style={{ color: '#333' }}>
                    support@kumbhatech.com
                  </a>
                </li>
                <li>
                  <i className="fa fa-phone" aria-hidden="true"></i>
                  <a href="tel:7880002227" style={{ color: '#333' }}>
                    +91-7880002227
                  </a>
                </li>
              </ul>

              <ul className="social-icons">
                <li><Link to="https://twitter.com/KumbhaTech" target="_blank" aria-label="Twitter"><i className="fa fa-twitter" aria-hidden="true"></i></Link></li>
                <li><Link to="https://www.linkedin.com/company/kumbha-technology" target="_blank" aria-label="LinkedIn"><i className="fa fa-linkedin" aria-hidden="true"></i></Link></li>
                <li><Link to="https://www.instagram.com/kumbhatech/" target="_blank" aria-label="Instagram"><i className="fa fa-instagram" aria-hidden="true"></i></Link></li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>
          © 2017-{currentYear} kumbhatech Solution. All Rights Reserved | kumbhatech Solution name and logo are registered by kumbhatech Solution.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
